import { combineEpics } from 'redux-observable'
import { debounceTime, switchMap } from 'rxjs/operators'

import { Epic } from 'modules/store'

import { AppProviders } from '../../../app/app.module'
import * as fromActions from './suggest-adapter.actions'

export const suggestOptionsEpic: Epic<fromActions.SuggestActions, any, AppProviders> = (
  actions$,
  _,
  { httpClient }
) => {
  return actions$.ofType<fromActions.GetSuggestDataAction>(fromActions.GET_SUGGEST_DATA).pipe(
    debounceTime(350),
    switchMap(({ payload }) =>
      httpClient
        .get<{ items: any[]; count: number }>(payload.endpointUrl, {
          params: payload.params,
        })
        .then(({ data }) => new fromActions.GetSuggestDataSuccessAction({ storeId: payload.storeId, data: data.items }))
        .catch((reason) => new fromActions.GetSuggestDataFailureAction(reason))
    )
  )
}

export default combineEpics(suggestOptionsEpic)



// WEBPACK FOOTER //
// ./src/modules/forms/suggest-adapter/suggest-adapter.epic.ts